/**
 * Create analytics addSourceMiddleware fn that stamps each event
 */
export const createConsentStampingMiddleware = (getCategories) => {
    const fn = async ({ payload, next }) => {
        payload.obj.context.consent = {
            ...payload.obj.context.consent,
            categoryPreferences: await getCategories(),
        };
        next(payload);
    };
    return fn;
};
//# sourceMappingURL=consent-stamping.js.map